import forms from "../locales/legacy/forms.json";
import skudock from "../locales/legacy/skudock.json";
import kylendarV1 from "../locales/legacy/kylendar-v1.json";
import kylendarV2 from "../locales/legacy/kylendar-v2.json";
import kylendarV2Dynamic from "../locales/legacy/kylendar-v2-dynamic.json";

// Source phrases are stable keys; translations never depend on array position.
export const legacyMessages = { ...forms, ...skudock, ...kylendarV1, ...kylendarV2, ...kylendarV2Dynamic };

export function translateLegacy(language, source, parameters = {}) {
  if (typeof source !== "string") return source;
  const key = source.replace(/\s+/g, " ").trim();
  const translated = legacyMessages[key]?.[language];
  const message = translated === undefined ? source : `${source.match(/^\s*/)[0]}${translated}${source.match(/\s*$/)[0]}`;
  return message.replace(/\{(\w+)\}/g, (placeholder, name) =>
    Object.prototype.hasOwnProperty.call(parameters, name) ? String(parameters[name]) : placeholder
  );
}
